import Image from 'next/image'
import Link from 'next/link'

import { useAuth } from '~/providers/auth-provider'

const PreprodBadge = () => {
	if (process.env.NEXT_PUBLIC_APP_ENV === 'prod') return null

	return (
		<span className='ml-2 hidden pt-2 text-[10px] uppercase leading-none text-slate-400 md:block'>
			{process.env.NEXT_PUBLIC_APP_ENV}
		</span>
	)
}

export const BrandLink = () => {
	const { isAuth } = useAuth()

	return (
		<Link
			href={isAuth ? '/dashboard' : '/'}
			className='text-primary items-center md:mr-auto md:flex md:flex-row md:items-start md:pb-1 md:text-4xl md:font-bold md:leading-none'
		>
			<Image
				src='/images/v2/logo.png'
				alt='logo'
				height={40}
				width={40}
				className='md:hidden'
			/>
			<span className='hidden md:block'>cocoon space</span>
			<PreprodBadge />
		</Link>
	)
}
